export declare type NotificationType = "info" | "warning" | "error";

export declare type NotificationPosition = "default" | "bottomRight" | "topRight";

export interface NotificationProps {
  dataCy?: string;
  children: React.ReactNode;
  className?: string;
  type?: NotificationType;
  position?: NotificationPosition;
}

const NotificationIcon: Record<NotificationType, string> = {
  info: "fa fa-info-circle",
  warning: "fa fa-exclamation-circle",
  error: "fa fa-exclamation-circle",
};

export const getIconNameForNotificationType = (notificationType: NotificationType) =>
  NotificationIcon[notificationType] || NotificationIcon.info;
